import styled from 'styled-components';
import {useState, useEffect, lazy, Suspense} from 'react';

const ProjectsSection = lazy(() => import('./sections/ProjectsSection'));
const AboutSectionComponent = lazy(() => import('./sections/AboutSection'));
const ExperienceSectionComponent = lazy(() => import('./sections/ExperienceSection'));
const InstagramSectionComponent = lazy(() => import('./sections/InstagramSection'));

const TitleContainer = styled.div`
  margin: 340px 50px 325px 60px;
  
  @media (max-width: 768px) {
    margin: 200px 20px 200px 20px;
    text-align: center;
  }
`
const Name = styled.p`
  font-size: 45px;
  font-weight: 700;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 32px;
  }
`
const CurrentRole = styled.p`
  font-size: 18px;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`
const Arrow = styled.button`
  margin-left: 50%;
  font-size: 20px;
  font-weight: 600;
  background: none;
  border: none;
  cursor: pointer;
  padding: 10px;
  border-radius: 80vh;
  transition: background-color 0.3s ease;
  color: inherit;

  &:hover {
    background: ${props => props.theme.navHoverBackground};
    border: 1px solid ${props => props.theme.navBorder};
  }

  @media (max-width: 768px) {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
`
const Footer = styled.footer`
  text-align: center;
  padding-bottom: 20px;
  
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
  
  background: ${props => props.theme.cardBackground};
`

const ScrollToTop = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 20px;
  padding: 10px;
  border-radius: 80vh;
  transition: background-color 0.3s ease;
  color: inherit;
  margin-bottom: 15px;

  &:hover {
    background: ${props => props.theme.navHoverBackground};
    border: 1px solid ${props => props.theme.navBorder};
  }
`

const Copyright = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${props => props.theme.textSecondary};
`

function Home() {
  const [hoveredJourney, setHoveredJourney] = useState(null);
  const [showArrow, setShowArrow] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const arrowElement = document.querySelector('#current-role');
      if (arrowElement) {
        const arrowPosition = arrowElement.getBoundingClientRect().top;
        setShowArrow(arrowPosition > 0);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://embedsocial.com/cdn/ht.js";
    script.id = "EmbedSocialHashtagScript";
    document.head.appendChild(script);

    return () => {
      const existingScript = document.getElementById("EmbedSocialHashtagScript");
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  const scrollToProjects = () => {
    document.getElementById('projects').scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <TitleContainer>
        <Name>Sebastian Lopez</Name>
        <CurrentRole id="current-role">Software Engineer @ SpaceX</CurrentRole>
      </TitleContainer>
      <Arrow id="scroll-arrow" onClick={scrollToProjects}>↓</Arrow>

      <Suspense fallback={<div>Loading projects...</div>}>
        <ProjectsSection />
      </Suspense>

      <Suspense fallback={<div>Loading about section...</div>}>
        <AboutSectionComponent />
      </Suspense>

      {/* <Suspense fallback={<div>Loading experience...</div>}>
        <ExperienceSectionComponent />
      </Suspense> */}

      <Suspense fallback={<div>Loading Instagram feed...</div>}>
        <InstagramSectionComponent />
      </Suspense>

      <Footer>
        <ScrollToTop onClick={scrollToTop}>↑</ScrollToTop>
        <Copyright>© {new Date().getFullYear()} Sebastian Lopez. All rights reserved.</Copyright>
      </Footer>
    </>
  );
}

export default Home;